import React from "react";
import "./MenuOverlay.css";

function MenuOverlay({ isOpen, onClose, onNavigate }) {
  const menuItems = [
    { name: "HOME", page: "home" },
    { name: "NATURE", page: "nature" },
    { name: "BABY SHOOT", page: "baby-shoot" },
    { name: "WEDDING", page: "wedding" },
    { name: "BIRTHDAY", page: "birthday" },
  ];

  if (!isOpen) return null;

  const handleItemClick = (page) => {
    onNavigate(page);
  };

  return (
    <div className="menu-overlay">
      <h1 className="menu-title">RAGHAV KHANNA</h1>
      <div className="menu-content">
        <nav className="menu-nav">
          {menuItems.map((item, index) => (
            <button
              key={index}
              className="menu-item"
              onClick={() => handleItemClick(item.page)}
            >
              {item.name}
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
}

export default MenuOverlay;
